import type { AnalyticsEventProperties } from 'core/analytics/analytics-types'
import { trackAnalyticsEvent } from 'core/hooks/useAnalytics'
import type { TrajectoryEvent } from 'core/constants/trajectory-analytics'

export const trackTrajectoryEvent = (event: TrajectoryEvent, properties?: AnalyticsEventProperties) => {
  trackAnalyticsEvent(event, properties)
}
